import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { login } from '../../features/auth/authLoginSlice'

import '../../styles/modalForm.css'

const Login = () => {
	const dispatch = useDispatch()

	const navigate = useNavigate()

	const { loading, admin } = useSelector((state) => state.authLogin)

	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')

	const loginSubmitHandler = (e) => {
		e.preventDefault()
		let data = {
			email,
			password,
		}
		dispatch(login(data))
	}

	const viewHandler = () => {
		let pass = document.getElementById('password')
		let view = document.getElementById('view')
		const type = pass.getAttribute('type') === 'password' ? 'text' : 'password'
		pass.setAttribute('type', type)

		view.classList.toggle('fa-eye-slash')
	}

	useEffect(() => {
		if (admin) {
			navigate('/admin/dashboard/home')
		}
	}, [admin, navigate])

	return (
		<>
			<section className='login'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-md-5'>
							<div className='login_form'>
								<h4 className='text-center'>
									<strong>ADMIN SIGN IN</strong>
								</h4>
								<form className='' onSubmit={loginSubmitHandler}>
									<label className='label'>Email </label>
									<input
										type='text'
										value={email}
										className='form-control mb-3'
										onChange={(e) => setEmail(e.target.value)}
									/>
									<label className='label'>Password</label>
									<div style={{ position: 'relative', marginBottom: '2rem' }}>
										<input
											type='password'
											id='password'
											value={password}
											className='form-control mb-1'
											onChange={(e) => setPassword(e.target.value)}
										/>
										<i
											className='fa fa-eye view'
											id='view'
											onClick={viewHandler}
										></i>
									</div>

									<div className='text-center'>
										<button
											className='form-control modal_btn'
											disabled={email && password && !loading ? false : true}
										>
											{loading ? (
												<i className='fas fa-spinner fa-spin'></i>
											) : (
												<span className='text-white'>Login</span>
											)}
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default Login
